export default __webpack_public_path__ + "static/media/pm-icon.511edc46.png";